import { render, staticRenderFns } from "./AlreadyDeliveryPopup.vue?vue&type=template&id=5c0b70fc&scoped=true&"
import script from "./AlreadyDeliveryPopup.vue?vue&type=script&lang=ts&"
export * from "./AlreadyDeliveryPopup.vue?vue&type=script&lang=ts&"
import style0 from "./AlreadyDeliveryPopup.vue?vue&type=style&index=0&id=5c0b70fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0b70fc",
  null
  
)

export default component.exports